import React from "react";
import styles from "./AdvisorCard.module.scss";
import { MapPin, CheckCircle } from 'react-feather'
import { Link } from "react-router-dom"
import useGetProfilePicture from "../../hooks/useGetProfilePicture";
const classnames = require('classnames');

function AdvisorCard(props) {

    const { professionalId, cognitoUsername, firstName, lastName, city, state, companyName, specialities, firmId } = props.data;  // dont have starRating or reviewCount
    
    const shownTags = specialities.slice(0, 3);
    const profilePicture = useGetProfilePicture(firmId  && firmId > 0 ? professionalId : cognitoUsername);

    //fix this
    // if (specialities.length > 3) {
    //     shownTags.push("+" + (specialities.length - 3))
    // }

    return (
        <>
            <Link className={styles.advisorCardContainer} to={`/advisor-profile/${professionalId}/${firstName}-${lastName}/`}>
                    {profilePicture && <img loading="lazy" className={classnames(styles.profilePicture, !(profilePicture === '/images/profilePictureDefault.svg') ? styles.gradientBorder : styles.pupleBorder)} src={profilePicture} alt="profile_picture" ></img>}
                    <p className={styles.location}><MapPin size={10} />  {city}, {state}</p>
                    <h3 className={styles.textSpacing}>{firstName} {lastName}</h3>
                    <p className={styles.textSpacing}>{companyName}</p>
                    {/* <div className={styles.occupationText}>
                        <CheckCircle size={15} />
                        <h3>Verified by AdFi</h3>
                    </div> */}
                    <div className={styles.tagsHeader}>
                        <h4>Specialities and Expertise</h4>
                    </div>
                    <div className={styles.tagsContainer}>
                        {shownTags.map((tag, index) => (
                            <div key={index} className={styles.tag}>{tag.value}</div>
                        ))}
                    </div>
            </Link>
        </>
    )
}

export default AdvisorCard;
